<div *ngIf="form">
  <ng-container *ngIf="!isJuridicPerson">
    <natural-form
      [est]="est"
      [estMun]="estMun"
      [mun]="mun"
      [munParr]="munParr"
      [parr]="parr"
      [(form)]="form"
      [icase]="data.task.case"
    ></natural-form>
    <!-- <other-person [(form)]="form"></other-person> -->
  </ng-container>
  <ng-container *ngIf="isJuridicPerson">
    <legal-form
      [est]="est"
      [estMun]="estMun"
      [mun]="mun"
      [munParr]="munParr"
      [parr]="parr"
      [(form)]="form"
    ></legal-form>
  </ng-container>
</div>
